<template>
  <div id="variants" class="mt-3">
    <h2>Variants</h2>
    <div
      v-for="(groupItems, groupName) in variants"
      :key="groupName"
      class="row variantGroup align-items-center"
    >
      <div class="row col-12"><span class="variantGroupName">{{groupName}}:</span></div>
      <router-link
      v-for="variant in groupItems"
      :key="variant.id"
      :to="{name: 'product',
        params: {product: variant.id},
        query: $route.query
      }"
      replace
      class="variant">
          <img
            v-if="variant.images && variant.images[0]"
            :src="imageUrl(variant.images[0].sizes, 'small')"
            class="variantImage"
            :alt="product.title"
          >
          <img
            v-else
            src="/resources/images/content/default-image-3.png"
            class="variantImage"
          >
          <div class="variantName">{{variant.name}}</div>
        </router-link>
    </div>
  </div>
</template>

<script>
import { imageUrl } from "@/utils";

export default {
  name: "Variants",
  components: {},
  props: ["variants", "product"],
  methods: {
    imageUrl
  }
};
</script>

<style lang="scss" scoped>
.variant {
  display: inline-block;
  text-align: center;
  padding: 5px;
  font-size: 0.7em;
  width: 90px;
  max-width: 90px;
  word-wrap:break-word;
  color:$CTred;
  // padding:5px;
  margin:5px;
  outline: 1px transparent solid;
  transition: 0.2s;
  &.router-link-exact-active,
  &:hover {
    transition:0.3s;
    outline: 1px black solid;
  }
  img {
    width: 50px;
    height: 50px;
    display:block;
    margin-left:auto;
    top: 0;
    margin-right:auto;
  }
  .variantName{
    height: 32px;
    overflow: hidden;
  }
}
.variantGroupName{
  padding-left:5px;
  font-weight: bold;
}
</style>
